import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { delPdtWishList, savePdtWishList } from '@app/actions/shoppingmall/product-wishlist.action';
import { setWAlert } from '@app/actions/w-alert.action';
import { ActionConstant } from '@app/common/constant/action-constant';
import { CommonConstant } from '@app/common/constant/common.constant';
import { WAlertConstant } from '@app/common/constant/w-alert-icon.constant';
import { AuthUtil } from '@app/common/util/auth.util';
import { ConvertUtil } from '@app/common/util/convert.util';
import { OrdPdtModel } from '@app/models/shoppingmall/order-pdt.model';
import { PdtWishListState } from '@app/selectors/shoppingmall/product-wishlist.selector';
import { WAlertState } from '@app/selectors/w-alert.selector';
import { environment } from '@enviroments/environment';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ProductWishlistService {

    constructor(private _http: HttpClient,
        private _wishListStore: Store<PdtWishListState>,
        private _wAlertStore: Store<WAlertState>,
        private _translate: TranslateService,
        private _toastService: ToastrService) { }

    loadPdtWishList(params: any): Observable<OrdPdtModel[]> {
        let url = `${environment.apiUrl}/product/wishlist/search`;

        return this._http.post<OrdPdtModel[]>(url, params);
    }

    countPdtWishList(params: any): Observable<number> {
        let url = `${environment.apiUrl}/product/wishlist/count`;

        return this._http.post<number>(url, params);
    }

    savePdtWishList(pdtCd: string, userId: string) {
        let url = `${environment.apiUrl}/product/wishlist/save?comId=${environment.comId}&userId=${userId}&pdtCd=${pdtCd}`

        return this._http.post(url, {});
    }

    delPdtWishList(pdtCd: string, userId: string) {
        let url = `${environment.apiUrl}/product/wishlist/del?comId=${environment.comId}&userId=${userId}&pdtCd=${pdtCd}`

        return this._http.delete(url);
    }

    deleteProductWishList(params: any) {
        let url = `${environment.apiUrl}/product/wish-list/delete`;
        return this._http.request('delete', url, { body: params, observe: 'response' });
    }

    deleteAllProductWishList(params: any) {
        let url = `${environment.apiUrl}/product/wish-list/delete/all`;
        return this._http.request('delete', url, { body: params, observe: 'response' });
    }

    addWishList(pdtCd: string, wishYN: string): string {
        let member = AuthUtil.getLoginedInfo();
        if (member && AuthUtil.isLogined()) {
            if (wishYN == CommonConstant.YES) {
                wishYN = CommonConstant.NO;
                this._wishListStore.dispatch(delPdtWishList({ userId: ConvertUtil.convertToString(member.userid), pdtCd: pdtCd }));
                this._toastService.success(this._translate.instant('wish-list.delete.success'));
            } else {
                wishYN = CommonConstant.YES;
                this._wishListStore.dispatch(savePdtWishList({ userId: ConvertUtil.convertToString(member.userid), pdtCd: pdtCd }));
                this._toastService.success(this._translate.instant('wish-list.save.success'));
            }
        } else {
            this._wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.confirm, message: this._translate.instant('msgRequiredLogin'), action: ActionConstant.ACTION_CONFIRM_LOGIN } }));
        }

        return wishYN;
    }
}
